import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Message } from "lib/components/index";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";

import { MainView } from "lib/components/index";
import CSSModules from "lib/utils/css-modules";
import { initializeApp, removeAlert, fetchApp } from "modules/app/actions";
import styles from "./App.less";

@connect(
  (state) => ({
    initialized: state.app.initialized,
    alerts: state.app.alerts,
    appError: state.app.appError,
    fetchAppDone: state.app.fetchAppDone,
    fetchAppLoading: state.app.fetchAppLoading,
    fetchAppFailed: state.app.fetchAppFailed,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeApp,
        removeAlert,
        fetchApp,
      },
      dispatch
    )
)
@DragDropContext(HTML5Backend)
@CSSModules(styles)
export default class App extends React.PureComponent {
  componentDidMount() {
    const { initialized, initializeApp } = this.props;
    initializeApp({ reset: !initialized });
  }

  handleAlertClose(alert) {
    const { removeAlert } = this.props;
    removeAlert(alert);
  }

  render() {
    const { appError, alerts, children, fetchAppFailed, fetchAppLoading, fetchAppDone, fetchApp } = this.props;
    return (
      <div styleName="container" key={I18n.locale}>
        {appError && <MainView.Dimmer failed errorTitle={appError} />}
        {fetchAppFailed && (
          <MainView.Dimmer
            failed
            errorTitle={I18n.t("papp.app.App.fetch_app_error_title")}
            retry={fetchApp}
            errorId={"0038"}
          />
        )}
        {fetchAppLoading && <MainView.Dimmer loading />}
        {fetchAppDone && children}
        {alerts.length > 0 && (
          <div styleName="alerts">
            {alerts.map((alert) => (
              <Message
                key={alert.uuid}
                styleName="alert"
                className={alert.type}
                content={alert.content}
                onDismiss={this.handleAlertClose.bind(this, alert)}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/App.jsx